import React from 'react';
import Box from '@mui/material/Box';

const ICON_MAP = {
  creditCard: '/images/icons/credit-card.svg',
  bank: '/images/icons/bank.svg',
  investments: '/images/icons/investments.svg',
  house: '/images/icons/house.svg',
  shield: '/images/icons/shield.svg',
  wallet: '/images/icons/wallet.svg',
  barChart: '/images/icons/bar-chart.svg',
  globe: '/images/icons/globe.svg',
  piggyBank: '/images/icons/piggy-bank.svg',
  folder: '/images/icons/folder.svg',
};

/**
 * Custom SVG icon component that replaces MUI icons with FinMaple's
 * minimalist illustration icons. Renders as an <img> via MUI Box
 * (avoids inline style hydration mismatch from browser serialization).
 *
 * @param {string} name - Key from ICON_MAP
 * @param {number} size - Width/height in px (default 24)
 */
const CustomIcon = React.forwardRef(({ name, size = 24, style, className, sx, ...rest }, ref) => (
  <Box
    component="img"
    ref={ref}
    src={ICON_MAP[name]}
    alt=""
    width={size}
    height={size}
    draggable={false}
    sx={{
      display: 'inline-block',
      verticalAlign: 'middle',
      objectFit: 'contain',
      flexShrink: 0,
      ...sx,
    }}
    className={className}
    {...rest}
  />
));

CustomIcon.displayName = 'CustomIcon';

export default CustomIcon;
export { ICON_MAP };
